import React from 'react'

const InternalServerError = (): React.ReactElement => (
  <div>Internal Server error</div>
)

export default InternalServerError
